import { DataSource, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTopMatchProfileDetail extends Layout {
    labelAvailableTractors: Label;
    labelScoring: Label;
    panelAvailTractor: Panel;
    panelComparisons: Panel;
    panelDetails: Panel;
    sourceTopmatchDetailGroup: DataSource;
    sourceTopmatchProfileDetails: DataSource;
    tableDetailGroup: Table;
    textboxDescr: Textbox;
    textboxRadius: Textbox;
    textboxScore: Textbox;
    textboxSearchType: Textbox;
    textboxTractorStatus: Textbox;
    textboxWeight: Textbox;
}
